<template>
    <page-container class="sign"
                    :class="{ 'content': !hideNavigate}">
        <el-breadcrumb slot="header"
                       v-if="!hideNavigate"
                       separator="/">
            <el-breadcrumb-item :to="{ path: '/home' }"
                                replace>电子印章</el-breadcrumb-item>
            <el-breadcrumb-item>
                <a>我要签章</a>
            </el-breadcrumb-item>
        </el-breadcrumb>

        <div class="header">
            <el-button class="grey-text small-font"
                       v-if="!hideNavigate"
                       type="text"
                       @click="$router.push('/home')">&lt; 返回上一页</el-button>

        </div>

        <div class="upload-contract transform-center">
            <div class="current-seal"
                 v-if="!isPersonal && !isEtl && !isEcloud"
                 v-loading="loading">
                <div class="title">
                    <i class="iconukey"></i> 当前印章
                </div>
                <img :src="seal.image"
                     alt="" v-if="hasRegisterNo" >
                <div class="box-footer horizonal-line transform-center">
                    {{seal.name}}
                </div>
                <div v-if="seal.status != 1 && hasRegisterNo"
                     class="status-layer">
                    <h3 class="text-center status">{{seal.status | statusApply}}</h3>
                </div>
                <div v-if="!hasRegisterNo" class="text-center">当前证书没有统一社会信用代码</div>
            </div>
            <!-- 上传 -->
            <el-upload class="upload-demo"
                       :class="{'adjust-width': isPersonal}"
                       drag
                       :before-upload="beforeAvatarUpload"
                       :show-file-list="false"
                       :accept="isZWFWSEAL?'.pdf,.ofd':'.pdf'"
                       :on-success="uploadSuccess"
                       :on-progress="uploadLoading"
                       :on-error="uploadError"
                       :action='`${this.BASE_APP_PATH}/document/upload`'>
                <svg style="font-size:60px;"
                     v-if="isZWFWSEAL"
                     class="icon"
                     aria-hidden="true">
                    <use xlink:href="#iconofd-gray"></use>
                </svg>
                <svg style="font-size:60px;"
                     class="icon"
                     aria-hidden="true">
                    <use xlink:href="#iconpdf1"></use>
                </svg>
                <span class="el-upload__text">
                    <em v-if="fileName">{{fileName}}</em>
                    <em v-else>点击上传要签署的文件，开始签署</em>
                </span>
                <div class="el-upload__tip important-descript"
                     v-if="isPersonal || isEtl || isEcloud"
                     slot="tip">上传签署的PDF电子文件，文件大小不超过30MB，如需上传非PDF格式的电子文件，请先转换为PDF格式的电子文件后再上传</div>
                 <div class="el-upload__tip important-descript"
                     v-if="isUkeyLogin"
                     slot="tip">上传签署的PDF或OFD电子文件，文件大小不超过30MB，如需上传非PDF或OFD格式的电子文件，请先转换为PDF或OFD格式的电子文件后再上传</div>
                <el-progress v-show="fileName"
                             class="mt10"
                             :show-text="false"
                             status="exception"
                             :stroke-width="4"
                             :percentage="percentage"></el-progress>
                <div
                    v-if="fileName"
                    class="model-screen transform-center"
                >
                    <i class="iconshangchuan"></i> 重新上传
                </div>
            </el-upload>
        </div>

        <div class="etl-seal-list" v-if="isEtl || isEcloud">
            <div class="title mb10">选择印章</div>
            <div class="etl-seal-selector" v-loading="loading">
                <div class="etl-current-seal"
                    v-for="(seal, index) in sealList"
                    :key="index"
                    :class="{ 'selected': selectedSealIndex === index }"
                    @click="selectedSealIndex = index">
                    <!-- <div class="title">
                        <i class="iconukey"></i>
                    </div> -->
                    <img :src="seal.image"
                        alt="">
                    <div v-if="seal.status != 1"
                        class="status-layer">
                        <h3 class="text-center status">{{seal.status | statusApply}}</h3>
                    </div>
                </div>
                <div v-if="sealList.noSeal" class="transform-center no-seal-tips">
                    <i class="iconfont iconukey ukey-font"></i>
                    <p>暂无可用印章</p>
                </div>
            </div>
            <el-button class="next-step"
                   size="medium"
                   @click="doNext"
                   type="primary">下一步</el-button>
        </div>

        <div class="horizonal-line"></div>

        <div class="sign-table">
            <p class="small-font">已签署的文件

                <el-popover trigger="hover">
                    <p class="grey-text">
                        自助上传签署业务每日可签20次,<br>
                        文档可保存7日,请及时下载
                    </p>
                    <span class="fr grey-text"
                          slot="reference">
                        <i class="el-icon-question"></i>帮助
                    </span>
                </el-popover>
            </p>
            <el-table :data="tableData"
                      border>
                <el-table-column prop="title"
                                 label="文件名称">
                    <template slot-scope="scope">
                        <span class="name-ellipsis"
                              :title="scope.row.subject">
                            {{scope.row.subject}}
                        </span>
                    </template></el-table-column>
                <el-table-column prop="updateTime"
                                 label="签署时间"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="text"
                                   class="blue-text"
                                   @click="downloadContract(scope.row.id)">下载</el-button>
                        <el-button type="text"
                                   class="red-text"
                                   @click="deleteContract(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination class="sign-page"
                       background
                       @current-change="changePage"
                       :current-page.sync="filters.pageNo"
                       :page-size.sync="filters.pageSize"
                       layout="total, prev, pager, next"
                       :total="pageCount"></el-pagination>
    </page-container>
</template>

<script>
import { mapGetters } from 'vuex';
import PageContainer from "../../components/container.vue";

export default {
    name: "Sign",
    components: { PageContainer },
    data () {
        return {
            tableData: [],
            filters: {
                pageNo: 1,
                pageSize: 5,
            },
            fileName: '',
            percentage: 0,
            seal: {},
            sealList: [],
            selectedSealIndex: 0,
            verify: false,
            loading: true,
            pageCount: 0, // 总页数
            uploadSuccessResp: {
                // signSource: "",
                // zwdt_access_token: "",
                // document: "",
                contractId: '',
            },
            isZWFWSEAL:false,
            hasRegisterNo:true
        };
    },
    inject: ['app'],
    props: {
        hideNavigate: Boolean
    },
    watch: {
        filters: {
            handler () {
                this.getFileList();
            },
            deep: true,
            immediate: true
        },
        'app.picData': {
            handler (nv) {
                if (nv) {
                    this.getSealInfo();
                } else {
                    this.seal = {};
                    this.verify = true;
                }
            },
            immediate: true
        },
    },
    computed: {
        ...mapGetters(['isEtl', 'isEcloud']),
        quser () {
            return this.$store.getters.quser;
        },
        isPersonal () {
            return this.$store.getters.isPersonal;
        },
        isUkeyLogin() {
            return this.$store.getters.isLP && !this.$store.getters.isEtl;
        },
    },
    filters: {
        statusApply (status) {
            const map = new Map([
                [1, '有效'],
                [2, '已过期'],
                [3, '已吊销'],
                [4, '已冻结'],
                [5, '已否决'],
                [6, '待审核'],
                [7, '异常'],
            ]);
            return status && map.get(status) || '暂无印章';
        },
    },
    mounted () {
        // 延时加载列表，防止回调不及时
        setTimeout(() => {
            this.getFileList();
            (this.isEtl || this.isEcloud) && this.getSealList();
        }, 4000);
    },
    methods: {
        // 判断上传格式
        beforeAvatarUpload (file) {
            const isAllowType = file.name.includes('.pdf') || file.name.includes('.ofd');
            const isOverSize = file.size > 30 * 1024 * 1024;
            if (!isAllowType) {
                this.$message.error("上传文件只能是PDF/OFD格式！");
            }
            if (isOverSize) {
                this.$message.error("文件大小不能超过30M！");
            }
            if (!isOverSize && isAllowType) {
                this.percentage = 0;
                // this.fileName = '';
                this.fileName = file.name;
            }
            return !isOverSize && isAllowType;
        },
        uploadLoading (event) {
            this.percentage = event.percent;
        },
        // 文件上传成功，跳转路由
        uploadSuccess (response) {
            if (response.code !== 0) {
                this.uploadError(response.message);
                return;
            }
            // this.percentage = 0;
            // this.fileName = '';
            if (this.isEtl || this.isEcloud) {
                this.uploadSuccessResp = response;
                this.$message.success('文件上传完成');
                return;
            }

            this.$router.push({
                path: "/inlinesignfile",
                query: {
                    // id: response.document,
                    // zwdt_access_token: response.zwdt_access_token,
                    // signSource: response.signSource,
                    hideFrame: this.hideNavigate,
                    contractId: response.contractId,
                }
            });
        },

        beforeNextCheck () {
            if (!this.uploadSuccessResp.contractId) {
                this.$message.error('请先上传文件');
                return false;
            }
            const seal = this.sealList[this.selectedSealIndex];
            if (!seal) {
                this.$message.error('请先选择印章');
                return false;
            }
            return true;
        },

        /**
         * 下一步
         */
        async doNext () {
            let loading;
            try {
                loading = this.$loading({
                    text: '加载中...'
                });
                if (!this.beforeNextCheck()) {
                    return;
                }
                this.isEcloud && (this.saveEcloudSealData());
                this.isEtl && (await this.saveEtlSealData());
                this.$router.push({
                    path: "/inlinesignfile",
                    query: {
                        // id: this.uploadSuccessResp.document,
                        // zwdt_access_token: this.uploadSuccessResp.zwdt_access_token,
                        // signSource: this.uploadSuccessResp.signSource,
                        hideFrame: this.hideNavigate,
                        contractId: this.uploadSuccessResp.contractId,
                    }
                });
            } catch (error) {
                console.log(error);
            } finally {
                loading && loading.close();
            }
        },
        saveEcloudSealData() {
            // 电照选中的印章调用接口后再构建印章存储，企业云采取直接构建
            let seal = this.sealList[this.selectedSealIndex].originData;
            // 暂时更改对应字段名称
            seal = {
                ...seal,
                sealName: seal.name,
                sealPic: seal.picData,
                sealStatus: seal.status,
                specHeight: seal.spec.height,
                specWidth: seal.spec.width,
            };
            sessionStorage.selectedSeal = JSON.stringify(seal);
        },

        async saveEtlSealData () {
            try {
                let seal = this.sealList[this.selectedSealIndex].originData;
                // 暂时更改对应字段名称
                seal = {
                    ...seal,
                    sealName: seal.name,
                    sealPic: seal.picData,
                    sealStatus: seal.status,
                };
                const res = await this.axios.post('/seal/create/etl/seal', seal);
                if (res.data && res.data.code === 0) {
                    const result = res.data.result;
                    seal.id = result.id;
                    seal.specHeight = result.spec.height;
                    seal.specWidth = result.spec.width;
                    sessionStorage.selectedSeal = JSON.stringify(seal);
                    return Promise.resolve();
                } else {
                    this.$message.error(res.data.message);
                    return Promise.reject();
                }
            } catch (e) {
                console.log(e);
            }
        },

        async getSealList () {
            try {
                this.loading = true;
                // 如果是企业云登录则获取企业云印章
                const url = this.isEcloud ? '/seal/query/mobilecert/seals' : '/seal/query/etl/seals';
                const res = await this.axios.get(url);
                if (res.data.code === 0) {
                    const list = [];
                    const result = res.data.result;
                    if (result.length) {
                        result.map(seal => {
                            list.push(this.formatSealInfo(seal));
                        });
                        this.sealList = list;
                    } else {
                        this.$set(this.sealList, 'noSeal',true);
                    }
                } else {
                    this.$message.error(res.data.message);
                }
            } catch (e) {
                console.log(e);
            } finally {
                this.loading = false;
            }
        },

        formatSealInfo (seal) {
            const image = seal.sealPic || seal.picData || seal.pic_data;
            const name = seal.sealName || seal.seal_name;
            const status = seal.sealStatus || seal.seal_status || seal.status;
            return {
                image: `data:image/png;base64,${image}`,
                name,
                status,
                originData: seal,
            };
        },

        /**
        * 获取印章信息
        */
        async getSealInfo () {
            try {
                this.loading = true;
                let issure;
                let requsetData = new FormData();
                requsetData.append('sealData', this.app.sealData);
                requsetData.append('old', this.app.isOld);
                requsetData.append('picData', this.app.picData);
                requsetData.append('cert', this.app.cert);
                issure = await this.axios({
                    url: '/seal/verify',
                    method: 'POST',
                    data: requsetData
                });
                issure = issure.data;
                if (issure.code === 0) {
                    if (issure.result.pic_data) {
                        this.seal = this.formatSealInfo(issure.result);
                    }
                    this.isZWFWSEAL = issure.result.sealStructure === "ZWFWSEAL"
                    this.verify = issure.result.seal_status == 1;
                    clearInterval(this.timer);
                }
                if( issure.code === 1200005) {
                    this.hasRegisterNo = false
                }
            } catch (error) {
                this.verify = true;
                console.log(error);
            } finally {
                this.loading = false;
            }
        },

        // 文件上传失败
        uploadError (err) {
            this.percentage = 0;
            this.fileName = '';
            this.$message.error(err);
        },
        // 翻页改变当前页
        changePage (nv) {
            this.filters.pageNo = nv || 1;
        },

        // 下载
        downloadContract (id) {
            this.Utils.downloadByForm({
                action: `${this.BASE_APP_PATH}/document/download/${id}`,
                method: "GET"
            });
        },

        // 删除
        async deleteContract (id) {
            let loading, resp;
            try {
                await this.$confirm('是否确认删除本条记录？', '删除记录', { type: 'warning' });
                loading = this.$loading({
                    text: '加载中...'
                });
                resp = await this.axios({
                    url: '/document/delete',
                    method: 'POST',
                    params: { id }
                });
                resp = resp.data;
                if (resp.code === 0) {
                    this.$message.success('删除成功!');
                    this.filters.pageNo = 1;
                    this.getFileList();
                } else {
                    this.$message.success(resp.message);
                }
            } catch (error) {
                console.log(error);
            } finally {
                loading && loading.close();
            }
        },

        // 获取文件列表
        async getFileList () {
            let resp;
            try {
                resp = await this.axios({
                    url: "/document/list",
                    method: "GET",
                    params: this.filters
                });
                resp = resp.data;
                if (resp.code === 0) {
                    let datas = resp.result.result;
                    this.tableData = datas;
                    this.pageCount = resp.result.totalCount;
                } else {
                    this.$message.error(resp.message);
                }
            } catch (error) {
                console.log(error);
            }
        }
    },
    beforeDestroy () {
        clearInterval(this.timer);
    }
};
</script>
<style lang="less" scoped>
.sign {
    max-width: @body-width;
    margin: 0 auto;
    padding: 15px 0;

    .upload-contract {
        margin: 10px auto 40px;
        padding: 0 40px;
        align-items: flex-start;

        .important-descript {
            text-align: center;
            &:before {
                content: "*";
                color: @red;
                display: inline-block;
                width: 8px;
            }
        }
    }
    .current-seal {
        width: 120px;
        min-height: 145px;
        margin-right: 20px;
        border: 1px solid @border-color-base;
        position: relative;

        .title {
            background: @red;
            color: @white;
            text-align: center;
        }

        .status-layer {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            background: rgba(0, 0, 0, 0.5);
            color: @white;
            overflow: hidden;
            .status {
                transform: rotate(-30deg);
                background: rgba(216, 0, 0, 0.5);
                position: absolute;
                top: 50%;
                left: -15px;
                width: 150px;
            }
        }
        img {
            width: 90px;
            min-height: 90px;
            margin: 0 auto;
            user-select: none;
        }
        .box-footer {
            min-height: 30px;
            text-align: center;
        }
    }

    .etl-seal-list {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .title {
            width: 762px;
        }
        .etl-seal-selector {
            margin-bottom: 20px;
            overflow: auto;
            overflow-y: hidden;
            width: 762px;
            height: 162px;
            border: 1px solid @border-color-base;
            white-space: nowrap;
            .no-seal-tips {
                width: 100%;
                height: 100%;
                flex-direction: column;
                color: @theme-color;
                .iconfont {
                    font-size: 40px;
                }
            }
        }
        .etl-current-seal {
            width: 120px;
            height: 120px;
            margin: 20px;
            position: relative;
            vertical-align: middle;
            display: inline-flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            &.selected {
                border: 1px solid #409eff;
                &::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    right: 0;
                    border-top: 10px solid #409eff;
                    border-bottom: 10px solid transparent;
                    border-left: 10px solid transparent;
                    border-right: 10px solid #409eff;
                }
                &::after {
                    content: '';
                    position: absolute;
                    top: 1px;
                    right: 1px;
                    z-index: 1;
                    width: 7px;
                    height: 3px;
                    border-top: 1px solid white;
                    border-bottom: 1px solid transparent;
                    border-left: 1px solid transparent;
                    border-right: 1px solid white;
                    transform: rotate(135deg);
                }
            }
            img {
                user-select: none;
            }
        }
        .next-step {
            margin: 50px;
        }
    }

    .sign-table {
        margin: 0 auto;
        padding: 30px;
        .small-font {
            margin-bottom: 10px;
        }
    }

    .sign-page {
        padding: 0 30px 20px;
        text-align: right;
    }

    .header {
        padding: 20px;
    }
}
</style>
<style lang="less">
.sign {
    .upload-demo {
        width: calc(100% - 150px);

        &.adjust-width {
            width: 800px;
        }

        .el-upload {
            width: 100%;
        }
        .el-upload-dragger {
            width: 100%;
            height: 143px;
            padding: 40px 20px 0;
            background-color: @background-color-primary !important;
            .el-upload__text {
                display: inline-block;
                position: relative;
                top: -15px;
                left: 0;
                text-align: center;
            }
        }
    }
}
</style>

